import Drawer from 'material-ui/Drawer';
import styled from 'styled-components';

const StyledDrawer = styled(Drawer)``;

export { StyledDrawer as Drawer };
